import React from "react";
import { SlashSuggester } from "../SlashSuggester/SlashSuggester";
export const SlashSuggesterPluginView = ({ view, commands, suggesterCallbacksRegistry }) => {
    return (React.createElement(SlashSuggester, { view: view, commands: commands, suggesterCallbacksRegistry: suggesterCallbacksRegistry }));
};
